<template>
  <div id="main">
    <div class="content page-order-payment">
      <div class="gray-box clear">
        <div class="title">
          <h2>支付订单</h2>
        </div>
        <div class="box-inner order-info">
          <h3>提交订单成功</h3>
          <p class="payment-detail">
            请在 <span>24 小时内</span>完成支付，超时订单将自动取消。
          </p>
          <p class="payment-detail">我们将在您完成支付后的 72 小时内发货</p>
        </div>
        <div class="box-inner payment-checkout-panel clear">
          <span
            @click="onPay()"
            class="jianguo-blue-main-btn big-main-btn js-payment-order"
          >
            <a>现在支付</a>
          </span>
          <span class="prices">
            应付金额：
            <em
              ><span>¥ </span
              >{{ orderInfo[0].price + orderInfo[0].freight }}</em
            >
          </span>
        </div>
      </div>
      <div class="confirm-detail">
        <div class="info-title">订单编号</div>
        <p class="info-detail">{{ orderInfo.orderId }}</p>
      </div>
      <div class="confirm-detail">
        <div class="info-title">收货信息</div>
        <p class="info-detail">姓名：{{ orderInfo[0].receive[0].name }}</p>
        <p class="info-detail">联系电话：{{ orderInfo[0].receive[0].phone }}</p>
        <p class="info-detail">详细地址：{{ orderInfo[0].receive[0].add }}</p>
      </div>
      <div class="confirm-detail">
        <div class="info-title">发票信息</div>
        <p class="info-detail">发票类型：电子发票</p>
        <p class="info-detail">发票抬头：{{ orderInfo[0].invoices }}</p>
        <p class="info-detail">发票内容：购买商品明细</p>
      </div>
      <div class="confirm-table-title clear">
        <span class="name fn-left">商品信息</span>
        <span class="subtotal fn-right">小计</span>
        <span class="num fn-right">数量</span>
        <span class="price fn-right">单价</span>
      </div>
      <div class="confirm-goods-table">
        <div
          class="cart-items clear"
          v-for="item in orderInfo[0].goods"
          :key="item.goods"
        >
          <!-- <div class="name fn-left hide-row">
            <div class="name-cell">
              <router-link
                :to="{
                  name: 'Item',
                  query: { itemId: item.sku_id },
                }"
                :title="item.title + '(' + item.spec_json.show_name + ')'"
                target="_blank"
                >{{ item.title }}({{ item.spec_json.show_name }})</router-link
              ><br />
            </div>
          </div> -->
          <div class="subtotal fn-right">
            <div class="subtotal-cell">¥ {{ item.price * item.count }}</div>
          </div>
          <div class="goods-num fn-right">{{ item.count }}</div>
          <div class="price fn-right">¥ {{ item.price }}</div>
        </div>
      </div>
      <div class="order-discount-line">
        <p>
          商品总计： <span>¥ {{ orderInfo[0].price }}</span>
        </p>
        <p>
          运费： <span>+ ¥ {{ orderInfo[0].freight }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/payment.css";
export default {
  methods: {
    onPay() {
      const loading = this.$loading({
        lock: true,
        text: "支付中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        this.$router.push({
          name: "Shop",
        });
        this.$message({
          message: "支付成功",
          type: "success",
        });
        loading.close();
      }, 2000);
    },
  },
  computed: {
    orderInfo() {
      let orderId = this.$route.query.orderId;
      let orderData = this.$store.state.orderData;
      return orderData.filter((item) => {
        return item.orderId == orderId;
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/payment.vue